import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_SUBSCRIPTION } from '@/modules/subscription/router';
import { subscriptionService } from '@/services/subscription';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useSubscriptionItemTranslate() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        itemId: route.params.id as string,
        locale: null,
        title: '',
        description: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push({ name: ROUTE_NAME_SUBSCRIPTION.INDEX });
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.itemId != null,
        request: () => subscriptionService.text.get(model.itemId, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
            model.description = data.description;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
            model.description = '';
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => subscriptionService.text.update(model.itemId, model.locale, model.title, model.description),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => subscriptionService.text.remove(model.itemId, model.locale),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, beforeFetch, actions, localeSupportedOptions };
}
